import VideoBox from 'component/VideoBox'
import styled from 'styled-components'

export default styled(VideoBox).attrs({ columns: 1 })``
